/** 未登录时不应再被重定向到 /login 的路径（含公开页、登录页） */
export const SIGNED_OUT_REDIRECT_SKIP_PATHS = [
  "/login",
  "/signup",
  "/share",
  "/feishu-login",
  "/email-unsubscribe",
  "/integration-guide",
  "/mLogin",
  "/book-demo",
  "/transit",
] as const;

function safeDecodeReturnPath(raw: string): string {
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}

export function sanitizeReturnPath(raw: string): string {
  const decoded = safeDecodeReturnPath(raw || "/").trim();
  if (!decoded) return "/";
  let normalized = decoded;

  if (
    (normalized.startsWith('"') && normalized.endsWith('"')) ||
    (normalized.startsWith("'") && normalized.endsWith("'"))
  ) {
    normalized = normalized.slice(1, -1).trim();
  }

  if (!normalized) return "/";
  if (!normalized.startsWith("/")) {
    normalized = `/${normalized}`;
  }

  if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(normalized)) {
    return "/";
  }

  return normalized;
}

/** 飞书 returnTo：去掉会指回登录页自身的路径，避免授权失败后循环跳转 */
export function sanitizeFeishuReturnTo(raw: string): string {
  const path = sanitizeReturnPath(raw);
  if (path.startsWith("/feishu-login")) {
    return "";
  }
  return path === "/" ? "" : path;
}

export function shouldSkipSignedOutLoginRedirect(pathname: string): boolean {
  if (pathname.includes("organization")) {
    return true;
  }
  return SIGNED_OUT_REDIRECT_SKIP_PATHS.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`),
  );
}

/** 从当前地址拼 returnTo；去掉 search 里已有的 returnTo，避免一层层嵌套进 /feishu-login */
function buildReturnToFromPath(pathname: string, search: string): string {
  const params = new URLSearchParams(search);
  params.delete("returnTo");
  const qs = params.toString();
  return qs ? `${pathname}?${qs}` : pathname;
}

export function buildFeishuLoginQuery(params: {
  orgId: string;
  pathname: string;
  search: string;
}): URLSearchParams {
  const { orgId, pathname, search } = params;
  const searchParams = new URLSearchParams(search);
  const returnToInQuery = searchParams.get("returnTo");

  // 首页飞书入口：pathname 为 / 时只认 query 里的 returnTo（与 App 原注释一致）
  let returnTo =
    pathname !== "/"
      ? buildReturnToFromPath(pathname, search)
      : returnToInQuery || "";

  returnTo = sanitizeFeishuReturnTo(returnTo);

  const query = new URLSearchParams({ orgId });
  if (returnTo) {
    query.set("returnTo", returnTo);
  }
  return query;
}
